import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const isAuthenticated = sessionStorage.getItem("auth") === "true";

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}
